module.exports = __webpack_public_path__ + "static/media/button-reject-request.25f6df04.svg";